import { render } from "./truckPrint.vue?vue&type=template&id=0628f055&scoped=true"
import script from "./truckPrint.vue?vue&type=script&lang=js"
export * from "./truckPrint.vue?vue&type=script&lang=js"

import "./truckPrint.vue?vue&type=style&index=0&id=0628f055&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0628f055"]])

export default __exports__